import {SET_AVATAR} from '../constants';

export function setAvatar(avatar) {
    return {
        type: SET_AVATAR,
        payload: avatar
    };
}
